<template>
  <section class="section-container section-container-wider">
    <div class="section-container-header-box fade-up-animation">
      <p class="list-text">Our work</p>
    </div>
    <h1 class="section-container-heading">
      <p
        v-for="line in headingLines"
        :key="line.text"
        class="extra-large-text-list fade-up-animation"
        :class="{ 'special-text': line.special }">
        {{ line.text }}
      </p>
    </h1>
  </section>

  <section class="section-container section-container-wider">
    <div class="all-projects-grid">
      <nuxt-link
        v-for="caseStudy in caseStudies"
        :key="caseStudy.slug"
        :to="`/projects/${caseStudy.slug}`"
        class="all-projects-card fade-up-animation"
        :aria-label="`Read the ${caseStudy.name} case study`">
        <div class="all-projects-card-media">
          <img :src="caseStudy.image" :alt="caseStudy.name" loading="lazy" />
        </div>
        <div class="all-projects-card-body">
          <div class="all-projects-card-body-text">
            <p class="small-text-list text-uppercase">{{ caseStudy.industry }}</p>
            <h3 class="heading-3">{{ caseStudy.name }}</h3>
            <p class="body-text">{{ caseStudy.short_description }}</p>
          </div>
          <div class="all-projects-card-arrow" v-html="icons.rightArrowIcon"></div>
        </div>
      </nuxt-link>
    </div>
  </section>

  <section class="section-container section-container-wider section-container-double-gap">
    <h2 class="section-container-heading">
      <p
        v-for="line in ctaLines"
        :key="line.text"
        class="extra-large-text-list fade-up-animation"
        :class="{ 'special-text': line.special }">
        {{ line.text }}
      </p>
    </h2>
    <nuxt-link class="arrow-button arrow-button-bigger fade-up-animation" to="/#contact" aria-label="Start a project">
      <p class="heading-4-bold">Start a project</p>
      <div class="arrow-button-icon" v-html="[icons.rightArrowIcon, icons.rightArrowIcon]"></div>
    </nuxt-link>
  </section>
</template>

<script lang="ts" setup>
import { useFadeUpObserver } from '@/composables/useFadeUpObserver';
import icons from '~/icons';
import { caseStudies } from '@/data/caseStudies';

const headingLines = [
  { text: 'Things we', special: false },
  { text: 'have built.', special: true },
];

const ctaLines = [
  { text: 'Got something', special: false },
  { text: 'like this in mind?', special: true },
  { text: "Let's build it.", special: false },
];

useFadeUpObserver();

useSeo({
  title: 'Our Work | VORTEC',
  description:
    'A look at the products and platforms we have designed and built at VORTEC — web apps, mobile apps, SaaS platforms and brand experiences.',
  path: '/projects',
  jsonLd: [
    {
      '@type': 'CollectionPage',
      name: 'Our Work | VORTEC',
      description: 'A look at the products and platforms we have designed and built at VORTEC.',
      url: 'https://vortec.io/projects',
    },
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: 'https://vortec.io' },
        { '@type': 'ListItem', position: 2, name: 'Our Work', item: 'https://vortec.io/projects' },
      ],
    },
  ],
});
</script>
